// extracted by mini-css-extract-plugin
module.exports = {"innerSys":"login_innerSys__3ezxa","textDiv":"login_textDiv__KYPkt","textDivInner":"login_textDivInner__2syzR"};